<template style="background:#fff">
    <div class="bg-white">
        <div class="bg-white dashboard p-2 space-y-6">
    
            <div class="settings-container">
                <!-- Back Button -->
                <CRow class="header-row mb-3 position-relative">
                    <!-- Back Button on the Left -->
                    <CCol class="col-auto">
                        <CButton class="back-button" @click="$router.go(-1)">
                            ←
                        </CButton>
    
                    </CCol>
    
    
                </CRow>
                <br />
    
                <CRow class="mb-2 mt-2">
                    <CCol class="col-auto" v-for="(card, index) in cards" :key="index">
                        <CButton :class="['section-button', { 'active-button': activeCard === index }]" @click="setActiveCard(index)">
                            {{ card.title }}
                        </CButton>
                    </CCol>
                </CRow>
                <CRow class="mt-4">
                    <!-- Row 1: Feedback & Usage -->
                    <CRow class="mt-4" style="display: flex; width: 100%;">
                        <!-- Row 1: Feedback & Usage -->
                        <CCol sm="5" class="p-1" style="display: flex; width: 100%;" id="feedbackOverview">
                            <div class="card" style="flex-grow: 1; width: 100%;">
                                <h2 class="section-title">Customer Feedback Overview</h2>
                                <div class="grid grid-cols-1 gap-4">
                                    <canvas id="sentimentChart"></canvas>
                                    <div v-if="positive + neutral + negative === 0" class="text-center font-color-171717 mt-2">
  No feedback available.
</div>
                                </div>
                            </div>
                        </CCol>
    
                        <!-- Row 3: Regional & Performance -->
                        <CCol sm="7" v-if="isMultiLocation" class="p-1" style="display: flex; width: 100%;" id="voucherUsage">
                            <div class="card" style="flex-grow: 1; width: 100%;">
                                <h2 class="section-title">E-Voucher Usage</h2>
                                <canvas id="voucherChart" style="height: 200px; width: 100%;"></canvas>
                            </div>
                        </CCol>
                    </CRow>
    
                    <CRow style="display: flex; width: 100%;">
    
                        <!-- Row 2: Points & Growth -->
                        <CCol sm="8" class="p-1" style="display: flex; width: 100%;" id="pointsActivity">
                            <div class="card" style="flex-grow: 1; width: 100%;">
                                <h2 class="section-title">Collect Points Activity</h2>
                                <canvas id="pointsChart"></canvas>
    
                            </div>
                        </CCol>
    
                        <CCol sm="4" class="p-1" style="display: flex; width: 100%;" id="regionalBreakdown">
                            <div class="card" style="flex-grow: 1; width: 100%;">
                                <h2 class="section-title">Regional Breakdown</h2>
                                <div id="map" style="height: 400px; width: 100%;"></div>
                            </div>
                        </CCol>
                    </CRow>
    
    
                    <CRow style="display: flex; width: 100%;">
                        <CCol sm="6" class="p-1" style="display: flex; width: 100%;" id="customerGrowth">
                            <div class="card" style="flex-grow: 1; width: 100%;">
                                <h2 class="section-title">Customer Growth</h2>
                                <canvas id="growthChart"></canvas>
                            </div>
                        </CCol>
    
    
    
                        <CCol sm="6" class="p-1" style="display: flex; width: 100%;" id="businessPerformance">
                            <div class="card" style="flex-grow: 1; width: 100%;background:#f9f9f9">
                                <h2 class="section-title">Business Performance Insights</h2>
                                <CRow class="text-left">
                                    <CCol sm="12">
                                        <div class="kpi bg-white">
                                            <div class="kpi-label">Feedback</div>
                                            <div class="kpi-value">{{ feedbackToSalesRatio }}</div>
                                        </div>
                                    </CCol>
                                    <CCol sm="12" class="mt-2">
                                        <div class="kpi bg-white">
                                            <div class="kpi-label">Loyal Customers</div>
                                            <div class="kpi-value">{{ loyalCustomers }}</div>
                                        </div>
                                    </CCol>
                                    <CCol sm="12" class="mt-2">
                                        <div class="kpi bg-white">
                                            <div class="kpi-label">Avg Satisfaction Score</div>
                                            <div class="kpi-value">{{ avgSatisfaction }}</div>
                                        </div>
    
                                    </CCol>
    
                                </CRow>
                            </div>
    
                        </CCol>
                        <CCol sm="12" class="p-1" style="display: flex; width: 100%;" id="aiAnalysis">
                            <div class="card font-color-191919" style="flex-grow: 1; width: 100%;background:#f9f9f9;">
                                <h2 class="section-title">AI Analysis & Suggestions</h2>
                                <div class="p-1 m-2">
    
                                    <ToggleCard title="Service response time increased by 35% at Outlet B this week!">
                                        <CCard style="background:rgba(127, 99, 241, 0.20)">
                                            <p class="custom-18px-400 font-color-687588">Recommendation:</p>
                                            Interviewrr.ai is a state-of-the-art AI-powered platform designed to help job seekers improve their interview skills through automated question generation and video interviews. Users receive feedback from industry experts and AI algorithms to refine their
                                            skills and resumes.
                                        </CCard>
                                    </ToggleCard>
    
                                    <ToggleCard title="27% of reviews this week mentioned “expensive pricing”.">
    
                                    </ToggleCard>
    
                                    <ToggleCard title="Social media engagement has dropped 20% over the past 2 weeks.">
    
                                    </ToggleCard>
    
                                    <ToggleCard title="Repeat customer rate dropped from 45% to 29% in the last 30 days.">
    
                                    </ToggleCard>
    
                                    <ToggleCard title="Slow Service at Outlet A">
    
                                    </ToggleCard>
                                </div>
                            </div>
                        </CCol>
                    </CRow>
    
    
    
    
                </CRow>
                <br /><br />
            </div>
        </div>
    </div>
</template>

<script>
import Chart from 'chart.js';
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import ToggleCard from '../components/Toggle.vue';

export default {
    components: {
        ToggleCard,

    },

    data() {
        return {
            commonKeywords: ['service', 'price', 'quality', 'support', 'speed'],
            topVoucherCampaigns: ['Welcome2024', 'FlashSale', 'LoyaltyBonus'],
            redemptionRate: 75,
            rewardThresholdCount: 40,
            avgSpendBeforeReward: 250,
            returningUsers: 150,
            referralConversions: 30,
            feedbackToSalesRatio: 1000,
            loyalCustomers: 120,
            avgSatisfaction: 4.5,
            aiSuggestions: ['Improve response time', 'Consider lower pricing', 'More reward tiers', 'Increase marketing efforts'],
            isMultiLocation: true,

            voucherCampaignStats: [
                { name: 'Welcome2024', issued: 500, redeemed: 400 },
                { name: 'FlashSale', issued: 300, redeemed: 240 },
                { name: 'LoyaltyBonus', issued: 200, redeemed: 150 },
            ],
            growth: {
                labels: [], // Dynamic labels for the last 3 months
                newUsers: [] // New users data for the last 3 months
            },
            vouchers: [],
            user: {},
            activeCard: null,
            cards: [
                { title: 'Customer Feedback Overview', id: 'feedbackOverview' },
                { title: 'E-Voucher Usage', id: 'voucherUsage' },
                { title: 'Collect Points Activity', id: 'pointsActivity' },
                { title: 'Regional Breakdown', id: 'regionalBreakdown' },
                { title: 'Customer Growth', id: 'customerGrowth' },
                { title: 'Business Performance Insights', id: 'businessPerformance' },
                { title: 'AI Analysis & Suggestions', id: 'aiAnalysis' }
            ],
            sentiment: [], // Store API response data
            positive: 0,
            neutral: 0,
            negative: 0

        };
    },
    mounted() {
        try {
            const isAuth = this.UserAuth();
            if (isAuth) {
                this.GetInfoUser();
                this.GetCountCustomerGrowth(); // Fetch data from API
                this.initializeOtherCharts();
                this.initMap();
                this.GetEvoucherChart();

                this.$nextTick(() => {
      const map = L.map('map').setView([3.1390, 101.6869], 10); // Coordinates for Kuala Lumpur

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);
    });


            } else {
                this.GoToLogin();
            }
        } catch (error) {
            GoToLogin
            console.error("Error during authentication:", error);
            // Handle the error here
        }
    },
    methods: {
        setActiveCard(index) {
            this.activeCard = index;
            const element = document.getElementById(this.cards[index].id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    this.GetEvoucherChart(this.user.companyId);
                    this.GetDetailVoucherPerCompany(this.user.companyId);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        initializeOtherCharts() {
            // new Chart(document.getElementById('sentimentChart'), {
            //     type: 'pie',
            //     data: {
            //         labels: ['Positive', 'Neutral', 'Negative'],
            //         datasets: [{
            //             data: [55, 30, 15],
            //             backgroundColor: ['#7F63F1', '#CCC1F9', '#F1F1F1']
            //         }]
            //     }
            // });



            new Chart(document.getElementById('pointsChart'), {
                type: 'bar', // Use 'bar' for a bar chart
                data: {
                    labels: ['Jan 2025', 'Feb 2025', 'Mar 2025', 'Apr 2025'], // Example labels for months
                    datasets: [{
                            label: 'Points Earned',
                            data: [2000, 2200, 2500, 2800], // Example data for earned points
                            backgroundColor: '#7F63F1', // Light purple color for earned points
                            borderColor: '#673ab7', // Darker purple for the border
                            borderWidth: 1,
                            barThickness: 25, // Make the bars thicker
                            tension: 0.4, // Applies to line charts, remove it here
                        },
                        {
                            label: 'Points Redeemed',
                            data: [1500, 1600, 1800, 1900], // Example data for redeemed points
                            backgroundColor: '#CCC1F9', // Green color for redeemed points
                            borderColor: '#CCC1F9', // Dark green for the border
                            borderWidth: 1,
                            barThickness: 25, // Make the bars thicker
                            tension: 0.4, // Applies to line charts, remove it here
                        }
                    ]
                },
            });

            new Chart(document.getElementById('regionChart'), {
                type: 'bar',
                data: {
                    labels: ['KL', 'Penang', 'JB', 'Kota Kinabalu'],
                    datasets: [{
                        label: 'Engagement',
                        data: [200, 150, 100, 80],
                        backgroundColor: '#00bcd4'
                    }]
                }
            });
        },

        async GetCountCustomerGrowth() {
            try {
                const response = await this.$API.get(this.$GetCountCustomerGrowth);
                if (response.status === 200) {
                    // Populate the growth object with the fetched data
                    this.growth = response.data; // This will contain Labels and NewUsers as keys
                    this.updateGrowthChart(); // Update growth chart after data is fetched
                } else {
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },

        // Update the Growth Chart with dynamic data after API call
        updateGrowthChart() {
            // Use the correct keys from the API response (Labels and NewUsers)
            if (this.growth.Labels && this.growth.NewUsers && this.growth.Labels.length > 0 && this.growth.NewUsers.length > 0) {
                const ctx = document.getElementById('growthChart').getContext('2d');

                // Destroy the previous chart instance if it exists
                if (this.growthChartInstance) {
                    this.growthChartInstance.destroy();
                }

                this.growthChartInstance = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: this.growth.Labels, // Use Labels from API response
                        datasets: [{
                            label: 'New Users',
                            data: this.growth.NewUsers, // Use NewUsers from API response
                            borderColor: '#673ab7',
                            fill: true,
                            backgroundColor: 'rgba(146, 138, 253, 0.2)'
                        }]
                    }
                });
            } else {
                console.error("Growth data is missing or incomplete");
            }
        },
        initMap() {
            console.log("Initializing Map..."); // Log this to ensure it's being called
            const map = L.map("map").setView([4.2105, 101.9758], 6); // Coordinates for Peninsular Malaysia

            L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                attribution: "&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors",
            }).addTo(map);

            const peninsulaGeoJSON = {
                type: "Feature",
                geometry: {
                    type: "Polygon",
                    coordinates: [
                        [
                            [6.6055, 101.2085],
                            [6.7004, 100.6094],
                            [6.3132, 99.9986],
                            [5.6821, 99.6274],
                            [5.4795, 99.8227],
                            [4.7388, 99.7675],
                            [4.4019, 100.1726],
                            [4.2105, 101.9758],
                            [3.6954, 102.8016],
                            [3.0421, 102.3593],
                            [2.7201, 103.3105],
                            [3.3207, 104.0372],
                            [4.2105, 101.9758],
                        ],
                    ],
                },
            };

            const peninsulaStyle = {
                color: "#800080", // Purple color
                weight: 2,
                opacity: 0.7,
                fillColor: "#800080", // Fill with purple
                fillOpacity: 0.3,
            };

            L.geoJSON(peninsulaGeoJSON, {
                style: peninsulaStyle,
            }).addTo(map);
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        async GetEvoucherChart(id) {
            try {
                const response = await this.$API.get(this.$GetAllVoucherById + "?companyId=" + id, {
                    withCredentials: true,
                });

                if (response.status === 200 && response.data && response.data.WeeklyStats) {
                    const stats = response.data.WeeklyStats;

                    const labels = stats.map(item => item.Week);
                    const claimData = stats.map(item => item.Claim);
                    const redeemData = stats.map(item => item.Redeem);

                    // Generate Chart
                    const ctx = document.getElementById('voucherChart').getContext('2d');
                    new Chart(ctx, {
                        type: 'line',
                        data: {
                            labels: labels,
                            datasets: [{
                                    label: 'Issued',
                                    data: claimData,
                                    backgroundColor: function(context) {
                                        const gradient = context.chart.ctx.createLinearGradient(0, 0, 0, context.chart.height);
                                        gradient.addColorStop(0, 'rgba(127, 99, 241, 0.3)'); // light purple
                                        gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
                                        return gradient;
                                    },
                                    borderColor: '#7F63F1', // dark purple
                                    fill: true,
                                    tension: 0.4,
                                    pointRadius: 4,
                                },
                                {
                                    label: 'Redeemed',
                                    data: redeemData,
                                    backgroundColor: function(context) {
                                        const gradient = context.chart.ctx.createLinearGradient(0, 0, 0, context.chart.height);
                                        gradient.addColorStop(0, 'rgba(184, 155, 255, 0.3)'); // lighter purple
                                        gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
                                        return gradient;
                                    },
                                    borderColor: '#B89BFF', // lighter purple line
                                    fill: true,
                                    tension: 0.4,
                                    pointRadius: 4,
                                }
                            ]
                        },
                        options: {
                            scales: {
                                x: {
                                    grid: {
                                        display: false // Hides the x-axis grid lines
                                    }
                                },
                                y: {
                                    grid: {
                                        display: false // Hides the y-axis grid lines
                                    }
                                }
                            }
                        }
                    });

                } else {
                    console.error("No stats data received:", response);
                }
            } catch (error) {
                console.error("Error fetching voucher chart:", error);
            }
        },
        async GetDetailVoucherPerCompany(id) {
            try {
                const response = await this.$API.get(this.$GetDetailVoucherPerCompany + "?companyId=" + id);
                console.log("Full API response:", response.data);

                // Depending on structure, try one of these:
                this.sentiment = response.data.data || response.data.voucher || response.data;

                // Ensure it's always an array
                if (!Array.isArray(this.sentiment)) {
                    this.sentiment = [this.sentiment]; // wrap single object in array
                }

                this.processChartData();
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },

        calculateAverage(summary) {
            if (!summary || typeof summary !== 'string') return 0; // guard against null/undefined/non-string
            const ratings = summary.match(/(\d+)\/10/g);
            if (!ratings) return 0;
            const sum = ratings.reduce((acc, val) => acc + parseInt(val), 0);
            return sum / ratings.length;
        },

        classifyRating(average) {
            if (average < 4) return 'Negative';
            if (average <= 6) return 'Neutral';
            return 'Positive';
        },

        processChartData() {
            this.positive = 0;
            this.neutral = 0;
            this.negative = 0;

            this.sentiment.forEach(item => {
                item.users.forEach(user => {
                    const average = this.calculateAverage(user.summary);
                    const classification = this.classifyRating(average);

                    if (classification === 'Positive') this.positive++;
                    else if (classification === 'Neutral') this.neutral++;
                    else if (classification === 'Negative') this.negative++;
                });
            });

            this.updateChart(); // Make sure this exists in the same `methods` object
        },

        updateChart() {
            if (this.sentimentChart) {
                this.sentimentChart.destroy(); // clear previous chart
            }

            const total = this.positive + this.neutral + this.negative;

            this.sentimentChart = new Chart(document.getElementById('sentimentChart'), {
                type: 'pie',
                data: {
                    labels: ['Positive', 'Neutral', 'Negative'],
                    datasets: [{
                        data: total === 0 ? [1, 0, 0] : [this.positive, this.neutral, this.negative], // fallback data
                        backgroundColor: ['#7F63F1', '#CCC1F9', '#F1F1F1']
                    }]
                },
                options: {
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function(context) {
                                    if (total === 0) return 'No data';
                                    return context.label + ': ' + context.raw;
                                }
                            }
                        },
                        legend: {
                            display: true
                        }
                    }
                }
            });
        }
    }
};
</script>
  
<style scoped>
body {
    background-color: white !important;
    /* Force white background */
}

.dashboard {
    max-width: 1300px;
    margin: auto;
}

.section-title {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 1rem;
    border-bottom: 2px solid #f1f5f9;
    padding-bottom: 0.5rem;
    text-align: left;
}

.card {
    background: white;
    padding: 1.5rem;
    border-radius: 1rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.card-details p {
    margin-bottom: 0.5rem;
    font-size: 0.95rem;
}

.kpi {
    background-color: #f0f8ff;
    padding: 1rem;
    border-radius: 1rem;
}

.kpi-label {
    font-size: 0.7rem;
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.25rem;
}

.kpi-value {
    font-size: 1.5rem;
    font-weight: bold;
    color: #1f2937;
}

.kpi span {
    display: block;
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 0.25rem;
}

.word-cloud li {
    display: inline-block;
    margin: 0.25rem;
    background: #e0f7fa;
    padding: 0.4rem 0.8rem;
    border-radius: 0.5rem;
    font-size: 0.9rem;
}

#map {
    width: 100%;
    height: 350px;
    /* Adjust the height as per your layout */
}

.settings-container {
    background-color: white;
}


</style>
<link rel="stylesheet" href="https://unpkg.com/leaflet/dist/leaflet.css" />
  